import { useWindowSize } from 'common/hooks';

function hasValue(value) {
  return value !== undefined && value !== null && value !== '';
}

function getResponsiveValue(fields, viewport) {
  if (viewport.isMobile && hasValue(fields.mobileValue)) {
    return fields.mobileValue;
  }

  if (viewport.isTablet && hasValue(fields.tabletValue)) {
    return fields.tabletValue;
  }

  if (viewport.isDesktop && hasValue(fields.desktopValue)) {
    return fields.desktopValue;
  }

  if (hasValue(fields.desktopValue)) return fields.desktopValue;
  if (hasValue(fields.tabletValue)) return fields.tabletValue;
  if (hasValue(fields.mobileValue)) return fields.mobileValue;

  return undefined;
}

export default function useCustomStyle(settings) {
  const viewport = useWindowSize();

  const style = Object.fromEntries(
    settings
      ? settings
          .map((obj) => {
            const { fields, sys } = obj;
            const type = sys.contentType.sys.id;
            const key = fields.key || fields.name;

            if (['lpAsset', 'lpLink'].includes(type)) {
              return [[key, obj]];
            }
            if (key === '--background-image') {
              return [
                [
                  'background',
                  `url(${fields.value}), linear-gradient(to bottom, #F3D8AB, #F3D8AB)`,
                ],
                ['background-blend-mode', 'multiply'],
                ['background-repeat', 'no-repeat'],
                ['background-size', 'contain'],
              ];
            }
            if (type === 'keyValue') {
              return [[key, fields.value]];
            }

            return [[key, getResponsiveValue(fields, viewport)]];
          })
          .flat()
      : []
  );

  return [
    (node) => {
      if (node) {
        for (const [key, value] of Object.entries(style)) {
          node.style.setProperty(key, value, 'important');
        }
      }
    },
    style,
  ];
}
